var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerSmallFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .667A7.332 7.332 0 0 0 .665 8a7.332 7.332 0 0 0 7.333 7.334A7.332 7.332 0 0 0 15.333 8 7.332 7.332 0 0 0 7.999.667Zm2.735 9.255-.592.74a.473.473 0 0 1-.665.073l-1.981-1.47a1.183 1.183 0 0 1-.444-.922v-4.6a.473.473 0 0 1 .473-.474h.946a.473.473 0 0 1 .474.473V8l1.715 1.257a.473.473 0 0 1 .074.665Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerSmallFillIcon);
export default __webpack_public_path__ + "static/media/timer-small-fill-icon.fa0781d6d70701f9d251a56ffb750864.svg";
export { ForwardRef as ReactComponent };